import React, { useEffect, useRef, useState } from 'react';
import { LAZY } from '@yme/common/constants';
import { useIsMount } from '@yme/hooks/useIsMount';
import { useIsOnScreen } from '@yme/hooks/useIsOnScreen';
import { ACCELEROMETER, AUTO_PLAY, CLIPBOARD_WRITE, ENCRYPTED_MEDIA, GYROSCOPE, POST_MESSAGE_VALUE, } from './constants';
import { VideoPlayerStyled } from './styled';
export function VideoPlayer(props) {
    const { videoPath, isPlaying, isAutoStopAllowed, isHiddenForKeyboard, height = '100%', width = '100%', title = '', children, dataTestId = 'default', } = props;
    const [srcIframe, setSrcIframe] = useState('');
    const iframePlayerRef = useRef(null);
    const { isOnScreen, ref } = useIsOnScreen();
    const isMount = useIsMount();
    useEffect(() => {
        if (!isMount && iframePlayerRef?.current) {
            const newPath = `${videoPath}`;
            setSrcIframe(newPath);
        }
    }, [iframePlayerRef, videoPath, isPlaying, isMount]);
    useEffect(() => {
        if (isAutoStopAllowed && !isOnScreen) {
            iframePlayerRef?.current?.contentWindow?.postMessage(POST_MESSAGE_VALUE, '*');
        }
    }, [isAutoStopAllowed, isOnScreen]);
    const tabIndex = !isHiddenForKeyboard || isOnScreen ? 0 : -1;
    const currentDataTestId = `${dataTestId}_VideoPlayer`;
    return (React.createElement(VideoPlayerStyled, { ref: ref },
        React.createElement("iframe", { "data-testid": currentDataTestId, tabIndex: tabIndex, src: srcIframe, title: title, ref: iframePlayerRef, width: width, height: height, frameBorder: "0", allowFullScreen: true, allow: `${ACCELEROMETER}; ${AUTO_PLAY}; ${ENCRYPTED_MEDIA}; ${GYROSCOPE}; ${CLIPBOARD_WRITE};`, role: "presentation", loading: LAZY }),
        children));
}
VideoPlayer.displayName = 'VideoPlayer';
